import * as React from "react";
import styles from "./TextArea.module.scss";
import classnames from "classnames";

export default function TextArea({ dataTestId, minLength, value, onChange, floatingText, error }) {
    return (
        <div style={{ position: "relative", width: "100%" }}>
            <textarea
                data-test-id={dataTestId}
                minLength={minLength}
                data-has-value={!!value}
                value={value}
                className={classnames(styles["textbox-answer-input"], error && styles["error"])}
                onChange={onChange}
            />
            <label className={styles["floating-label"]}>{floatingText}</label>
        </div>
    );
}
